define('views/parts/form/multi-select',[
    // Libs
    "underscore", "backbone", "mustache", "selectize", "utils",
    // Templates
    "text!templates/parts/form/multi-select.html"

], function(
    // Libs
    _, Backbone, Mustache, selectize, U,
    // templates
    TMultiSelect
) {

    /**
     * Needs a collection to populate the select options.
     */
    var VMultiSelect = Backbone.View.extend({

        template: TMultiSelect,
        events: {
            "click .multiselect-control": "onClick",
        },
        regions: {
            label: ".control-label",
            select: ".multiselect-control"
        },

        initialize: function(opt) {
            var options = this.options = _.extend({
                id: this.cid
            }, opt);

            options.option = _.extend({
                label: 'text',
                value: 'value'
            }, options.option);

            options.optgroup = _.extend({
                label: 'label',
                value: 'value'
            }, options.optgroup);

            this.selected = new Backbone.Collection();

            this.listenTo(this.selected, 'update', this.onSelectionUpdate);
            this.listenTo(this.collection, 'update', this.render);
        },

        render: function() {
            this.$el.html(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones();

            // this.addAll();
            var thisOptions = this.options,
                option = thisOptions.option,
                optgroup = thisOptions.optgroup;

            this.selectize = this.zone.$select.selectize({
                plugins: ['remove_button'],
                hideSelected: true,
                searchConjunction: 'and', // 'or'
                closeAfterSelect: true,
                // onChange: this.onChange.bind(this),
                onItemAdd: this.onSelect.bind(this),
                onItemRemove: this.onDeselect.bind(this),
                onFocus: this.onFocus.bind(this),
                //onInitialize: this.setSelectedItems("50612edc0b50c3861e00001f"),
                sortField: [
                    { field: option.label, direction: 'asc' },
                    { field: '$score' }
                ],
                searchField: thisOptions.searchField,
                // Options
                labelField: option.label,
                valueField: option.value,
                // Option Groups
                // optgroupField: 'optgroup',
                optgroupLabelField: optgroup.label,
                optgroupValueField: optgroup.value,
                lockOptgroupOrder: true,
                addPrecedence: true,
                create: true,
                showAddOptionOnCreate: false // Doesn't seems to work right now so I decided to hide 'add option' via css in _animated-session.scss
            }).data('selectize');

            return this;
        },

        resetSelectedTags: function() {
            this.selected.reset();
        },

        addAll: function() {
            var selectize = this.selectize;
            selectize.clearOptionGroups();
            selectize.clearOptions();

            if (this.options.subgroup) {
                this.collection.each(this.addSubGroup, this);
            } else {
                selectize.addOption(this.collection.toJSON());
            }
        },

        addSubGroup: function(model) {
            var subgroup = this.options.subgroup,
                group = model.sanitizedAttributes(null, { blacklist: [subgroup] }),
                selectizeOb = this.selectize;

            selectizeOb.registerOptionGroup(group);

            var items = _.map(model.get(subgroup), function(value) {
                value.optgroup = model.id;
                return value;
            }, this);

            selectizeOb.addOption(items);
        },

        updateOptions: function() {
            if (this.options.fetch) {
                this.collection.fetch({
                    context: this,
                    success: function() {
                        this.addAll();
                        this.selectize.refreshOptions();
                    }
                });
            } else {
                this.addAll();
                this.selectize.refreshOptions();
            }
        },

        ////////////
        // events //
        ////////////
        onSelect: function(value, $item) {
            this.selected.add({ id: value });
        },

        onDeselect: function(value) {
            this.selected.remove({ id: value });
        },

        onFocus: function() {
            if (_.isEmpty(this.selectize.options)) {
                this.updateOptions();
            }
        },

        onClick: function() {
            this.selectize.open();
        },

        onSelectionUpdate: function() {
            var options = this.options;
            _.callback(options.context, options.onUpdate, arguments);
        },

    });

    return VMultiSelect;

});

